import { AddressPrediction, AddressDetails } from 'types';

export enum TYPES {
  LOOKUP = '[ADDRESS]-LOOKUP',
  LOOKUP_SUCCESS = '[ADDRESS]-LOOKUP_SUCCESS',
  LOOKUP_FAILURE = '[ADDRESS]-LOOKUP_FAILURE',

  DETAILS = '[ADDRESS]-DETAILS',
  DETAILS_SUCCESS = '[ADDRESS]-DETAILS_SUCCESS',
  DETAILS_FAILURE = '[ADDRESS]-DETAILS_FAILURE',
}

export type AddressLookupActions = ILookup
  | ILookupSuccess
  | ILookupFailure
  | IDetails
  | IDetailsSuccess
  | IDetailsFailure;

// =====================
// Address lookup - triggers saga
// =====================
export interface ILookup {
  type: typeof TYPES.LOOKUP;
  payload: {
    searchTerm: string;
  };
}

export function actionLookup(searchTerm: string): ILookup {
  return {
    type: TYPES.LOOKUP,
    payload: {
      searchTerm,
    },
  };
}

// =====================
// Address lookup - success
// =====================
export interface ILookupSuccess {
  type: typeof TYPES.LOOKUP_SUCCESS;
  payload: {
    addressResults: AddressPrediction[];
  }
}

export function actionLookupSuccess(addressResults: AddressPrediction[]): ILookupSuccess {
  return {
    type: TYPES.LOOKUP_SUCCESS,
    payload: {
      addressResults,
    },
  };
}

// =====================
// Address lookup - failure
// =====================
export interface ILookupFailure {
  type: typeof TYPES.LOOKUP_FAILURE;
  payload: {
    error: string;
  };
}

export function actionLookupFailure(error: string): ILookupFailure {
  return {
    type: TYPES.LOOKUP_FAILURE,
    payload: {
      error,
    },
  };
}

export interface IDetails {
  type: typeof TYPES.DETAILS,
  payload: {
    isLoading: boolean;
    placeId: string;
  };
}

export function actionDetails(placeId: string): IDetails {
  return {
    type: TYPES.DETAILS,
    payload: {
      isLoading: true,
      placeId,
    },
  };
}

export interface IDetailsSuccess {
  type: typeof TYPES.DETAILS_SUCCESS,
  payload: {
    details: AddressDetails;
  };
}

export function actionDetailsSuccess(details: AddressDetails): IDetailsSuccess {
  return {
    type: TYPES.DETAILS_SUCCESS,
    payload: {
      details,
    },
  };
}

export interface IDetailsFailure {
  type: typeof TYPES.DETAILS_FAILURE,
  payload: {
    error: any,
  };
}

export function actionDetailsFail(error: any): IDetailsFailure {
  return {
    type: TYPES.DETAILS_FAILURE,
    payload: {
      error,
    },
  };
}
